// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status-tag{display:inline-block;justify-content:center;min-width:80px}`, "",{"version":3,"sources":["webpack://./src/components/Common/StatusTag/Style.scss"],"names":[],"mappings":"AAAA,YACE,oBAAA,CACA,sBAAA,CACA,cAAA","sourcesContent":[".status-tag {\n  display: inline-block;\n  justify-content: center;\n  min-width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
